import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, theme } from 'antd';
import { ShopOutlined, ToolOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import ShopifyStoreSettings from './components/ShopifyStoreSettings';
import { fetchShopifyStores } from './actions';
import './ShopifySettings.css';

const { TabPane } = Tabs;

const ShopifySettings = () => {
    const dispatch = useDispatch();
    const { shopifyStores, loading } = useSelector(state => state.shopifySettings);
    const [activeKey, setActiveKey] = useState('stores');
    const [loadedTabs, setLoadedTabs] = useState(new Set(['stores']));
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    // Load initial tab data on mount
    useEffect(() => {
        dispatch(fetchShopifyStores());
    }, [dispatch]);

    // Memoize the data fetching functions
    const fetchTabData = useCallback(async (tabKey) => {
        if (loadedTabs.has(tabKey)) {
            return;
        }

        try {
            switch (tabKey) {
                case 'stores':
                    await dispatch(fetchShopifyStores());
                    break;
                default:
                    break;
            }
            
            setLoadedTabs(prev => new Set([...prev, tabKey]));
        } catch (error) {
            console.error(`Error loading data for tab ${tabKey}:`, error);
        }
    }, [dispatch, loadedTabs]);

    const handleTabChange = useCallback((key) => {
        setActiveKey(key);
        fetchTabData(key);
    }, [fetchTabData]);

    return (
        <div
            style={{
                margin: '24px 16px',
                borderRadius: borderRadiusLG,
                minHeight: 280,
            }}
        >
            <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                type="card"
                tabBarGutter={5}
                className="category-management-tabs"
            >
                <TabPane
                    tab={<span><ShopOutlined /> Shopify Stores</span>}
                    key="stores"
                >
                    <ShopifyStoreSettings
                        shopifyStores={shopifyStores}
                        loading={loading}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default ShopifySettings;
